import React from 'react';
import { ReportCatalogItem, ReportType } from './types';
import '../../../components/common/CRMList.css';

interface ReportsListProps {
  reportTypes: Array<{ id: ReportType; label: string }>;
  selectedType: ReportType;
  onTypeChange: (type: ReportType) => void;
  reports: ReportCatalogItem[];
  selectedReportId: 'expense-by-property';
  onSelectReport: (reportId: 'expense-by-property') => void;
}

const ReportsList: React.FC<ReportsListProps> = ({
  reportTypes,
  selectedType,
  onTypeChange,
  reports,
  selectedReportId,
  onSelectReport
}) => {
  return (
    <div className="list">
      <div className="list-header">
        <h3>Reports</h3>
      </div>

      <div className="list-filter">
        <label className="app-form-label" htmlFor="report-type-filter">Report Type</label>
        <select
          id="report-type-filter"
          className="app-form-select"
          value={selectedType}
          onChange={(event) => onTypeChange(event.target.value as ReportType)}
        >
          {reportTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.label}
            </option>
          ))}
        </select>
      </div>

      <div className="list-items">
        {reports
          .filter((report) => report.type === selectedType)
          .map((report) => (
            <div
              key={report.id}
              className={`list-item ${selectedReportId === report.id ? 'selected' : ''}`}
              onClick={() => onSelectReport(report.id)}
            >
              <div className="list-item-main-info">
                <div className="list-item-name-section">
                  <span className="list-item-name">{report.label}</span>
                </div>
              </div>
              <div className="list-item-details">
                <div className="list-item-detail">
                  <span className="list-item-detail-value">{report.description}</span>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ReportsList;
